import { LocationSuggestionTypeCode } from '@abg/typings';
import { LocationSuggestionGroup } from '@abg/typings/biz/location.interface';

import { GroupInfo } from './suggestion-group.types';

export const getGroupInfo = (
  suggestionTypeCode: LocationSuggestionTypeCode,
  suggestionTypeCodeToGroupInfoMap: Partial<
    Record<LocationSuggestionTypeCode, GroupInfo>
  >,
): GroupInfo | undefined => {
  if (
    suggestionTypeCode !== 'CURRENT' &&
    suggestionTypeCode in suggestionTypeCodeToGroupInfoMap
  ) {
    return suggestionTypeCodeToGroupInfoMap[suggestionTypeCode];
  }

  return undefined;
};

/**
 * Returns a map of suggestionTypeCode to its corresponding group title
 * @param groupLabels
 * @returns
 */
export const getSuggestionTypeCodeToGroupInfoMap = (
  groupLabels: Record<string, string>,
): Record<
  Exclude<LocationSuggestionGroup, 'RAILWAY_BUS_STATION'>,
  GroupInfo
> => {
  // todo: change to siteGroup
  const {
    airportsLabel,
    showAllAirportsLabel,
    showingAllAirportsLabel,
    citiesLabel,
    showAllCitiesLabel,
    showingAllCitiesLabel,
    recentLabel,
    showAllRecentLabel,
    pointsOfInterestLabel,
    showAllPOILabel,
    showingAllPOILabel,
    neighborhoodLabel,
    showAllNeighborhoodLabel,
    showingAllNeighborhoodLabel,
    truckLabel,
    showAllTruckLabel,
    showingAllTruckLabel,
    currentReturnLabel,
    myLocationsLabel,
    avisFirstDeliveryGroupLabel,
    showAllAvisFirstDeliveryLabel,
    showingAllAvisFirstDeliveryLabel,
  } = groupLabels;

  return {
    RECENT: {
      title: recentLabel || '',
      showAll: showAllRecentLabel,
    },
    CURRENT_RESERVATION: {
      title: currentReturnLabel || '',
    },
    SAVED: {
      title: myLocationsLabel || '',
    },
    'OTR-CITY': {
      title: citiesLabel || '',
      showAll: showAllCitiesLabel,
      showingAll: showingAllCitiesLabel,
    },
    'OTR-POINT_OF_INTEREST': {
      title: pointsOfInterestLabel || '',
      showAll: showAllPOILabel,
      showingAll: showingAllPOILabel,
    },
    'ABG-AIRPORT': {
      title: airportsLabel || '',
      showAll: showAllAirportsLabel,
      showingAll: showingAllAirportsLabel,
    },
    AIRPORT: {
      title: airportsLabel || '',
      showAll: showAllAirportsLabel,
      showingAll: showingAllAirportsLabel,
    },
    CITY_DOWNTOWN: {
      title: neighborhoodLabel || '',
      showAll: showAllNeighborhoodLabel,
      showingAll: showingAllNeighborhoodLabel,
    },
    OTHER: {
      title: neighborhoodLabel || '',
      showAll: showAllNeighborhoodLabel,
      showingAll: showingAllNeighborhoodLabel,
    },
    NEIGHBOURHOOD: {
      title: neighborhoodLabel || '',
      showAll: showAllNeighborhoodLabel,
      showingAll: showingAllNeighborhoodLabel,
    },
    'ABG-NEIGHBOURHOOD': {
      title: neighborhoodLabel || '',
      showAll: showAllNeighborhoodLabel,
      showingAll: showingAllNeighborhoodLabel,
    },
    TRUCK: {
      title: truckLabel || '',
      showAll: showAllTruckLabel,
      showingAll: showingAllTruckLabel,
    },
    'ABG-TRUCK': {
      title: truckLabel || '',
      showAll: showAllTruckLabel,
      showingAll: showingAllTruckLabel,
    },
    'ABG-AVIS-FIRST-DELIVERY': {
      title: avisFirstDeliveryGroupLabel || 'Avis First Delivery',
      showAll: showAllAvisFirstDeliveryLabel,
      showingAll: showingAllAvisFirstDeliveryLabel,
    },
  };
};
